import React, { useMemo } from 'react';
import Link from 'next/link';
import moment from 'moment';

export const PressListing = ({ articles }) => {
    // Sort the articles by publication date
    const sortedArticles = useMemo(() => {
        // Remove featured article
        const filtered = articles.allPressArticles.filter((article) => !article.featured);

        // Sort by date
        return filtered.sort((a, b) => moment(b.publishedAt).diff(moment(a.publishedAt)));
    }, [articles]);
    return (
        <div className='pl'>
            <div className='pl-content'>
                {sortedArticles.map((article) => {
                    const showDate = new Date(article?.publishedAt).toLocaleDateString('en-gb', {
                        year: 'numeric',
                        month: 'short',
                        // Day: 'numeric',
                        timeZone: 'utc'
                    });
                    return (
                        <Link key={article.id} href={article.articleUrl} legacyBehavior>
                            <div className='listing-card' style={{ cursor: 'pointer' }}>
                                <div className='publication-date-container'>
                                    <div className='publication-title'>{article.sourceName}</div>
                                    <span className='publish-date'>{showDate}</span>
                                </div>
                                <img style={{ width: '100%' }} src={article.featuredImage.url} alt='featured image' />
                                <h3>{article?.title}</h3>
                                <p>{article.description}</p>
                                <a id='read-full' href={article.articleUrl}>
                                    Read Full Article <img src='/assets/icons/arrow-right.svg' alt='GO' />
                                </a>
                            </div>
                        </Link>
                    );
                })}
            </div>
            <style jsx>{`
                .pl {
                    width: 100%;
                    padding: 48px 60px;
                    user-select: none;

                    .pl-content {
                        display: grid;
                        grid-template-columns: 1fr 1fr;
                        grid-gap: 48px;
                        max-width: 1100px;
                        margin: 0 auto;

                        .listing-card {
                            transition: box-shadow 200ms ease;
                        }

                        .listing-card:hover {
                            box-shadow: rgba(0, 0, 0, 0.15) 0px 8px 24px;
                        }

                        .publication-date-container {
                            padding: 10px 0 30px;
                            color: #4f4f4f;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            .publication-title {
                                font-weight: 800;
                                font-size: 24px;
                                max-width: 330px;
                            }
                            .publish-date {
                                font-weight: 500;
                                font-size: 18px;
                            }
                        }

                        > div {
                            height: 640px;
                            background-color: #f3f3f3;
                            border-radius: 16px;
                            padding: 32px;
                            position: relative;

                            p {
                                height: 100px;
                                //background: red;
                                overflow: hidden;
                                text-overflow: ellipsis;

                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: initial;
                                display: -webkit-box;
                                -webkit-line-clamp: 0;
                                -webkit-box-orient: vertical;
                            }
                        }

                        #read-full {
                            position: absolute;
                            bottom: 8px;
                            left: 32px;
                            font-weight: 800;
                            font-size: 24px;
                            line-height: 28px;
                            background: -webkit-linear-gradient(135deg, #e637a8 2.69%, #e68137 75%);
                            -webkit-background-clip: text;
                            -webkit-text-fill-color: transparent;
                            text-decoration-line: underline;
                            display: flex;
                            margin-top: 40px;

                            img {
                                width: 35px;
                                height: auto;
                                margin-left: 6px;
                                margin-top: 4px;
                                transition: margin-left 150ms ease;
                            }
                        }

                        #read-full:hover {
                            img {
                                margin-left: 18px;
                            }
                        }
                    }
                }

                @media (max-width: 992px) {
                    .pl {
                        padding: 48px 40px;

                        .pl-content {
                            display: grid;
                            grid-template-columns: 1fr;

                            > div {
                                height: 760px;

                                p {
                                    font-size: 16px;
                                    max-height: 62px;
                                    -webkit-line-clamp: 3;
                                }
                            }
                        }
                    }
                }

                @media (max-width: 480px) {
                    .pl {
                        padding: 48px 40px;

                        .pl-content {
                            display: grid;
                            grid-template-columns: 1fr;
                            .publication-date-container {
                                flex-direction: column;
                                align-items: flex-start;
                                .publish-date {
                                    right: 16px;
                                    margin-top: 5px;
                                }
                            }

                            > div {
                                height: 600px;
                                padding: 30px 16px 16px;

                                p {
                                    height: 220px;
                                    overflow-y: hidden;
                                }
                            }
                            #read-full {
                                -webkit-text-fill-color: inherit;
                                background: #f3f3f3;
                                color: #e68137;
                            }
                        }
                    }
                }
            `}</style>
        </div>
    );
};
